import SecurityIcon from '@material-ui/icons/Security';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

// The page renders its own core-components Page/Header ("Modernisation
// Tracker"), so the framework header is off to avoid a second one. Moving to the
// framework/BUI header belongs to the MUI→BUI track.
// Not flag-gated: as before, only the sidebar item is behind `code-migrations`.
const codeMigrationsPage = PageBlueprint.make({
  params: {
    path: '/code-migrations',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/CodeMigrationsPage/CodeMigrationsPage').then(m => (
        <m.CodeMigrationsPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'code-migrations',
  title: 'Modernisation Tracker',
  icon: <SecurityIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  // Read by name by the sidebar's <FeatureFlagged with="code-migrations">.
  featureFlags: [{ name: 'code-migrations' }],
  routes: { root: rootRouteRef },
  extensions: [codeMigrationsPage],
});
